import React from 'react';
import { Wrench, Mail } from 'lucide-react';
import { useSettings } from '../context/SettingsContext';

const UnderConstruction = ({ message }) => {
  const settings = useSettings();
  const text =
    message ||
    "We're putting on the finishing touches. Please check back soon.";

  return (
    <div
      className="min-h-screen flex items-center justify-center bg-[#0b1020] text-white relative overflow-hidden px-6"
      data-testid="under-construction"
    >
      {/* Subtle radial glow */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top,_#1f2a4d_0%,_#0b1020_60%)]" />
      <div className="absolute -top-32 -right-32 w-[26rem] h-[26rem] rounded-full bg-teal-500/10 blur-3xl" />
      <div className="absolute -bottom-40 -left-32 w-[28rem] h-[28rem] rounded-full bg-amber-400/10 blur-3xl" />

      <div className="relative z-10 max-w-2xl text-center">
        <div className="inline-flex items-center justify-center w-20 h-20 rounded-3xl bg-amber-400/15 ring-1 ring-amber-300/30 mb-8">
          <Wrench className="w-10 h-10 text-amber-300" />
        </div>

        <p className="text-amber-300 text-xs tracking-[0.35em] uppercase mb-4">
          {settings.site_name || 'Our store'}
        </p>
        <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold mb-6 leading-[1.05]">
          We&rsquo;ll be back<br />
          <span className="text-teal-300">very soon.</span>
        </h1>

        <p className="text-base sm:text-lg text-slate-300 leading-relaxed mb-10 max-w-xl mx-auto">
          {text}
        </p>

        {settings.contact_email ? (
          <a
            href={`mailto:${settings.contact_email}`}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-white/10 border border-white/15 hover:bg-white/15 backdrop-blur-md transition-colors text-sm"
            data-testid="under-construction-email"
          >
            <Mail className="w-4 h-4" />
            <span className="text-slate-200">{settings.contact_email}</span>
          </a>
        ) : null}

        <p className="text-slate-500 text-xs mt-12">
          &copy; {new Date().getFullYear()} {settings.site_name || ''}
        </p>
      </div>
    </div>
  );
};

export default UnderConstruction;
